export enum AmendExplanationDialogMaxLenghtsEnum {
  REASON_EXPLANATION = 500,
}
